import { useQuery } from "@tanstack/react-query";

import {
  getModulesModuleIDQuestions,
  type ModuleQuestionDto,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { MODULES_QUERY_KEYS } from "./queryKeys";

export type { ModuleQuestionDto };

export { ModuleQuestionType } from "Infrastructure/Api/Api";

export function useModuleQuestionsQuery(moduleID: string | undefined) {
  return useQuery({
    queryKey: MODULES_QUERY_KEYS.questions(moduleID ?? ""),
    queryFn: processResponse(() => getModulesModuleIDQuestions(moduleID ?? "")),
    enabled: !!moduleID,
  });
}
